<template>
  <custom-modal :size="'max-w-xl'">
    <template v-slot:maincontent>
    <div class="w-full h-auto">
        <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
          <div class="bg-theme-green px-4 py-2 text-white">
            <div class="flex justify-between items-center">
              <div class="flex flex-col justify-start text-start ">
                <h2 class="font-semibold truncate text-single-line break-all mb-0.5 text-xl leading-6 mt-0 ml-2">Add User</h2>
              </div>
              
              <div class="flex flex-col">
                <div class="flex items-center content-center gap-2">
                  <button @click.prevent="close" class="text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer hover:bg-white border border-white p-4 rounded hover:text-theme-green  text-white ml-3">CANCEL</button>
                  <button @click.prevent="save" class="text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer bg-white p-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3">
                    <span>SAVE</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class=" bg-[#2B2C32] h-[520px] px-[16px] py-[16px] rounded-b-lg">
            <div class="w-full">
              <div :class="'input-wrapper ' + (form.email.error_type)">
                <label class="text-xs mb-1">Email*</label>
                <input placeholder="Email@address.com" v-model="form.email.value" @keyup="validateFields(['email'])" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                <p class="field-error label-text mt-1" v-if="form.email.error_message" v-text="form.email.error_message"></p>
              </div>
            </div>

            <div class="w-full mt-5">
              <div :class="'input-wrapper ' + (form.locationId.error_type)">
                <label class="text-xs tracking-[0.4px]">Locations</label>
                <SelectLocations
                  class="bg-gray-black rounded relative"
                  v-model="form.locationId.value"
                  :options="vg_locations"
                  placeholder="Select all that apply"
                />
                <p class="field-error label-text mt-1" v-if="form.locationId.error_message" v-text="form.locationId.error_message"></p>
              </div>
            </div>
          </div>
        </div>
    </div>
    </template>
  </custom-modal>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import ScheduleApi from '@/controllers/ScheduleReport'
import SelectLocations from '@/components/form/SelectLocations.vue'
import Helpers from '@/helpers';
import { mapGetters, mapActions } from "vuex";
import { useSnackbar } from "vue3-snackbar";

export default defineComponent({
  name: "ScheduleAdd",
  components: {
    SelectLocations
  },
  setup() {
    const form = ref({
      email: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'email']
      }, 
      locationId: {
        value: [],
        error_type: '',
        error_message: '',
        validations: []
      }
    })
    const snackbar = useSnackbar();

    return {form, snackbar}
  },
  computed: {
    ...mapGetters({
        vg_locations: 'location/list',
        vg_user: 'auth/user'
    })
  },
  methods: {
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },
    close(){
      this.$emit('close', false)
    },
    async save(){
      let validate = await this.validateFields(['email', 'locationId']);
      if(!validate) {
        return ;
      }

      this.va_spinner(true)
      let res = await ScheduleApi.create({
        reportName: 'end_of_day_summary_report',
        email: this.form.email.value,
        locationId: this.form.locationId.value,
      })
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message: Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status==201){
        this.$emit('close', true)
      }
      this.va_spinner(false)
    },
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  }
});

</script>
